import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=908f11e8&scoped=true&"
import script from "./Registration.vue?vue&type=script&lang=js&"
export * from "./Registration.vue?vue&type=script&lang=js&"
import style0 from "./Registration.vue?vue&type=style&index=0&id=908f11e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908f11e8",
  null
  
)

export default component.exports